import { ICTimeControlModel } from "./bfx-interface-controls.models";

import * as CubiqTS from "shared/cubiq-model-multi-asset";

export class ICGoodFromUntilModel {
  public dateValue: string;
  public marketValue: string;
  public timeValue: string | ICTimeControlModel;
  public timezoneValue: string;
  public dayOrder: boolean;
  public isNow: boolean = false;
  public isCustom: boolean = false;
  public valid: boolean;
  /** for oe-reverse */
  public isLoadPending: boolean = false;

  public defaultDayConstant: CubiqTS.Moment | null;

  constructor() {}
}
